import { render, staticRenderFns } from "./MenuConfigWindow.vue?vue&type=template&id=c8732aae&scoped=true"
import script from "./MenuConfigWindow.vue?vue&type=script&lang=js"
export * from "./MenuConfigWindow.vue?vue&type=script&lang=js"
import style0 from "./MenuConfigWindow.vue?vue&type=style&index=0&id=c8732aae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_cache-loader@4.1.0_webpack@4.47.0__css-load_01c2d4ae8744e2deff273ae17f28a58e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8732aae",
  null
  
)

export default component.exports